<template lang="pug">
  v-container(fluid)
    v-row.px-md-10(align='center' justify='center')
      v-col(cols="12").text-center
        h1
            v-icon(style="font-size:2em;") mdi-help
        h1.mt-10 La página que estás buscando no existe
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style scoped>

</style>